import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}
// 获取验证码接口
export function getcode (tel) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	return request({
		url: '/api/v1/sms/send/code/' + tel,
		method: 'get',
		params: obj
	})
}
// 验证code
export function checkcode (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/sms/verify/code',
		method: 'post',
		data: obj
	})
}

// 云食堂商家注册新增商家信息
export function merchantregister (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mercmerchant',
		method: 'post',
		data: obj,
		encryption: ['linkmanNumber', 'password']
	})
}
// 云食堂商家审核
export function businessmanAudit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mercmerchant/audit',
		method: 'post',
		data: obj
	})
}
// 分页获取商家列表
export function getBusinessman (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mercmerchant/page',
		method: 'get',
		params: obj
	})
}

// 查询商家列表
export function searchBusinessman (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mercmerchant/search',
		method: 'get',
		params: obj
	})
}

// 商户拉黑
export function BusinessmanBlock (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mercmerchant/block',
		method: 'put',
		data: obj
	})
}
// 商户修改
export function BusinessmanEdit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mercmerchant/edit',
		method: 'put',
		data: obj
	})
}
// 开启钉钉应用
export function useDingding (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/dingtalk/merchant/authorization',
		method: 'post',
		data: obj
	})
}

// 获取审核数据库
export function getDatabaseList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/dataset/list',
		method: 'get',
		params: obj
	})
}

// 修改商家权限
export const authorizeMerchant = data => {
	return request({
		url: '/api/v1/mercmerchant/authorize',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}

// 获取验证图片  以及token
export function reqGet (data) {
	return request({
		url: '/captcha/get',
		method: 'post',
		data
	})
}

// 滑动或者点选验证
export function reqCheck (data) {
	return request({
		url: '/captcha/check',
		method: 'post',
		data
	})
}

// 分页获取支付宝商家列表
export const getAlipaymanage = (content = {}) => {
	return request({
		url: '/api/v1/merchant/alipay/manage/page',
		params: { ...dataObj, content }
	})
}

// 新增商家绑定支付宝小程序信息
export function addBindAlipay (data) {
	return request({
		url: '/api/v1/merchant/alipay/manage/addBind',
		method: 'post',
		data
	})
}

// 修改商家支付宝信息
export function editBindAlipay (data) {
	return request({
		url: '/api/v1/merchant/alipay/manage/edit',
		method: 'post',
		data
	})
}

// 删除商家支付宝信息
export function deleteBindAlipay (data) {
	return request({
		url: '/api/v1/merchant/alipay/manage/delete',
		method: 'post',
		data
	})
}

// 小程序版本列表查询
export function getVersionList (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/queryVersionList',
		method: 'post',
		data
	})
}

// 小程序提交审核
export function applyAudit (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/applyAudit',
		method: 'post',
		data
	})
}

// 小程序退回开发
export function cancelAudited (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/cancelAudited',
		method: 'post',
		data
	})
}

// 取消小程序体验版
export function cancelExperience (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/cancelExperience',
		method: 'post',
		data
	})
}

// 小程序版本详情查询
export function getVersionDetail (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/queryVersionDetail',
		method: 'post',
		data
	})
}

// 生成商家小程序体验版
export function uploadAppVersion (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/uploadAppVersion',
		method: 'post',
		data
	})
}

// 小程序添加成员(开发者或体验者)
export function addMembers (data) {
	return request({
		url: '/api/v1/applet/alipay/manage/createMembers',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
